<template>
	<div class="home">
		<div class="wrap-container">
			<el-breadcrumb class="bread" separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/training_services' }">技术服务</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: `/training_services?courseType=${courseType}` }"
					>技术培训</el-breadcrumb-item
				>
				<el-breadcrumb-item>课程详情</el-breadcrumb-item>
			</el-breadcrumb>

			<div class="banner">
				<img src="../image/banner.png" alt="" />
			</div>

			<div class="course-box" v-if="detail.top_value">
				<div class="course-box-left">
					<div class="title">
						{{ detail.top_value.title }}
						<!-- 往期课程回顾 不显示 -->
						<div class="tab_box" v-if="detail_type">
							<span
								v-show="register_status[detail.top_value.register_status]"
								:data-tag="register_status[detail.top_value.register_status]"
								>{{ register_status[detail.top_value.register_status] }}</span
							>

							<!-- <span v-if="detail.top_value.register_type == 1">{{
                register_type[detail.top_value.register_type]
              }}</span
              ><span v-if="detail.top_value.register_type == 2" class="over">{{
                register_type[detail.top_value.register_type]
              }}</span>
              <span v-if="detail.top_value.register_type == 3" class="over">
                {{ register_type[detail.top_value.register_type] }}
              </span> -->
						</div>
						<!-- 往期课程回顾 不显示 end -->
					</div>
					<div class="item">授课老师：{{ detail.top_value.teacher }}</div>
					<div class="item"> 课程类型：{{ course_type[detail.top_value.course_type] }} </div>
					<div class="item">
						上课时间：{{
							detail.top_value.class_time_text ? detail.top_value.class_time_text : '-'
						}}

						{{
							detail.top_value.class_time_text && detail.top_value.end_class_time_text ? '-' : ''
						}}

						{{ detail.top_value.end_class_time_text ? detail.top_value.end_class_time_text : '' }}
					</div>
				</div>

				<!-- 往期课程回顾 不显示 -->
				<div class="course-box-right" v-if="detail_type">
					<div class="top">
						<div class="top_box" v-if="timeDown.leftd && detail.top_value.countdown">
							<!-- 报名截止: -->
							{{ course_title[detail.top_value.register_type] }}:
							<span class="timedown"
								><span class="time-num">{{ timeDown.leftd }}</span
								>天 <span class="time-num">{{ timeDown.lefth }}</span
								>时<span class="time-num">{{ timeDown.leftm }}</span
								>分<span class="time-num">{{ timeDown.lefts }}</span
								>秒</span
							>
						</div>
					</div>
					<div class="bottom">
						<div class="left">
							<div class="left-head-img-group">
								<div
									class="left-head-img"
									v-for="(item, index) in detail.top_value.user_head_img"
									:key="index"
								>
									<img :src="item" alt="" />
								</div>
							</div>
							{{ detail.top_value.register_number }}人报名
						</div>
						<div @click="goSignUp" class="right" v-if="detail.top_value.register_status == 3">
							重新报名
						</div>
						<div
							@click="goSignUp"
							class="right"
							v-if="detail.top_value.is_register == 0 && detail.top_value.register_type == 1"
						>
							我要报名
						</div>
						<div v-else class="right-end" v-show="detail.top_value.is_register != 1">
							<span>{{ registrationStatusText[detail.top_value.is_register] }}</span>
						</div>
					</div>
				</div>
				<!-- 往期课程回顾 不显示 end -->
			</div>
		</div>

		<!-- content -->
		<div class="content-box">
			<div class="round-img-shelf">
				<img class="round-img-more-1" src="../assets/imgs/qiu1@2x.png" alt="" />
			</div>
			<div class="content">
				<div
					v-if="detail.content_value"
					v-html="detail.content_value.details"
					class="rich-text"
				></div>
			</div>
			<!-- v-if="detail.login_college_url" 登录商学院 -->
			<div class="course-redup" v-if="detail.login_college_url">
				<img class="" src="../assets/imgs/kpbj.png" alt="" />
				<div class="title-redup">登录商学院查看更多</div>
				<div class="btn-redup" @click="goRedupTo(detail.login_college_url)">
					<span>去登录 <i class="redup-right el-icon-right"></i></span>

					<!-- <img class="redup-right" src="../assets/imgs/jiantouh.png" alt="" /> -->
				</div>
			</div>

			<div class="operate">
				<transition name="el-zoom-in-center" :appear="true" :duration="3000">
					<div class="material-list" v-if="detail.bottom_value && detail.bottom_value.length > 0">
						<div class="material-content" ref="materialc" v-show="activeNameMaterial != 'third'">
							<!-- Swiper -->
							<swiper :options="swiperOption" ref="mySwiper">
								<swiper-slide v-for="(item, index) in detail.bottom_value" :key="index">
									<div class="material-item" @click="nextDetail(item.id)">
										<img :src="item.banner" alt="" />
										<div class="material-item-popup">
											<div class="item-popup-title">{{ item.title }}</div>
										</div>
										<div class="material-item-tip">
											{{ course_type[item.course_type] }}
										</div>
									</div>
								</swiper-slide>
							</swiper>
							<div class="swiper-button-prev" slot="button-prev"></div>
							<div class="swiper-button-next" slot="button-next"></div>
						</div>
					</div>
				</transition>
			</div>

			<div class="bj">
				<img src="../image/qiu3.png" alt="" />
			</div>
		</div>

		<el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
			<span></span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { $courseCourseRegisterInfo, $courseCourseDetails } from '@/api';

	import { swiper, swiperSlide } from 'vue-awesome-swiper';
	import 'swiper/dist/css/swiper.css';

	export default {
		name: 'Home',
		data() {
			return {
				detail_type: null, // 课程类型 ==> 培训预告,往期回顾
				detail_is_jump: null, // 是否显示 登录商学院

				register_type: ['', '报名中', '已截止', '未开始', '报名失败'],
				register_status: ['', '报名中', '报名成功', '报名失败'],
				course_type: ['', '线上', ' 线下'],
				course_title: ['', '报名截止', '', '距报名'],
				course_index: 0,
				registrationStatusText: ['未报名', '已报名', '不可报名'],
				swiperOption: {
					slidesPerView: 3,
					spaceBetween: 20,
					loop: true,
					autoplay: {
						delay: 3000,
						stopOnLastSlide: false,
						disableOnInteraction: false,
					},
					// 显示分页
					pagination: {
						el: '.swiper-pagination',
						clickable: true, //允许分页点击跳转
					},
					// 设置点击箭头
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				},
				id: '',
				timer: null,
				timeDown: {},
				detail: {},
				centerDialogVisible: false,
				openVideo: false,
				materialDownloadIndex: false,

				courseType: null,
			};
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper;
			},
		},
		destroyed() {
			clearInterval(this.timer);
			this.timer = null;
		},
		mounted() {
			let { id, courseType } = this.$route.query;
			this.id = id;
			this.courseType = courseType;
			this.getclassDetail(this.id);
		},
		components: {
			swiper,
			swiperSlide,
		},
		methods: {
			goRedupTo(url) {
				if (!url) {
					// console.log("跳转路径为空！");
					return;
				}
				// window.open(url, "_blank");
				// console.log(url);
				window.location.href = url;
			},
			nextDetail(id) {
				this.$router.push({ query: { id } });
				this.getclassDetail(id);
			},
			// 显示剩余时间
			showTimeDown() {
				clearInterval(this.timer);
				this.timer = null;

				let nowTime = new Date();
				let top_val = this.detail.top_value;

				let top_val_time = {
					// type: top_val.register_type, // 1=报名中, 2=已截止 ,3=未开始报名
					// time: top_val.start_time
					type: null,
					time: null,
				};
				let type_obj = { 1: 'countdown', 2: 0, 3: 'start_time' };
				top_val_time.type = top_val.register_type;
				top_val_time.time = top_val[type_obj[top_val.register_type]];

				this.timeDown = this.timeOld(nowTime, top_val_time.time); // 防止延迟
				this.timer = setInterval(() => {
					if (top_val_time.time <= 0) {
						if (top_val.register_type != 2) {
							this.getclassDetail(this.id, 1);
						} else {
							clearInterval(this.timer);
							this.timer = null;
						}
					}
					this.timeDown = this.timeOld(nowTime, top_val_time.time);

					top_val_time.time--;
					this.$forceUpdate();
				}, 1000);
			},
			goSignUp() {
				let token = this.$store.state.userInfo.token;
				if (token) {
					this.$router.push({
						path: '/sign_up',
						query: {
							id: this.id,
						},
					});
				} else {
					this.$message({
						message: `未登录不可报名`,
						showClose: true,
					});
				}
			},
			onBindOpenVideo() {
				this.openVideo = true;
			},
			closeVideo() {
				this.openVideo = false;
			},
			onBindMaterialMouse(el) {
				this.materialDownloadIndex = el;
			},
			onBindMaterialMouseout() {
				this.materialDownloadIndex = '';
			},
			getclassDetail(id, timer_sate) {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)',
				});
				$courseCourseDetails({
					course_id: id,
				})
					.then((res) => {
						if (res) {
							res.data.content_value.details = res.data.content_value.details.replaceAll(
								'<video',
								'<video '
							);
							this.detail = res.data;
							this.detail_type = res.data.top_value.type == 1; // 1=培训预告,2=往期回顾
							this.detail_is_jump = res.data.top_value.is_jump == 1; // 是否跳转商学院:1=是,2=否
							// this.detail = res.data.top_value.;

							this.swiperOption.loop = res.data.bottom_value.length >= 3 ? true : false;
							// console.log(this.swiperOption, '轮播图数据');
							this.showTimeDown();
							// console.log(res);
						}
						loading.close();
					})
					.catch((err) => {
						loading.close();
					});
			},
			activeNameMaterial() {},
			timeOld(nowTime, time) {
				//time && time > 0
				if (time && time > 0) {
					var nowtime = new Date(); //获取当前时间
					var lefttime = nowTime.getTime() + time * 1000 - nowtime.getTime(), //距离结束时间的毫秒数
						leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24)), //计算天数
						lefth = Math.floor((lefttime / (1000 * 60 * 60)) % 24), //计算小时数
						leftm = Math.floor((lefttime / (1000 * 60)) % 60), //计算分钟数
						lefts = Math.floor((lefttime / 1000) % 60); //计算秒数

					return {
						leftd,
						lefth,
						leftm,
						lefts,
					};
					// return (
					//   leftd + " 天 " + lefth + " 小时 " + leftm + " 分钟 " + lefts + " 秒 "
					// ); //返回倒计时的字符串
					// return leftm + "分钟" + lefts + "秒"; //返回倒计时的字符串
				} else {
					return {
						leftd: '00',
						lefth: '00',
						leftm: '00',
						lefts: '00',
					};
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.swiper-container {
		width: 100%;
		height: 100%;
	}
	.wrap-container {
		position: relative;
		box-sizing: border-box;
		display: inline-block;
		width: 100%;
		margin-bottom: 200px;
		// min-height: 100vh;
		background-color: #000;

		.bread {
			margin: calc(var(--proportion) * 40px) calc(var(--proportion) * 160px);
			margin-left: 10%;
			z-index: 10;
			position: absolute;
			top: 0;
		}
		.banner {
			height: 500px;
			overflow: hidden;
			width: 100%;
			object-fit: cover;
		}
		.course-box {
			display: flex;
			justify-content: space-between;
			width: 68.5%;
			// background-color: #fff;
			background-color: #252525;
			margin-left: 15.5%;
			align-items: center;
			position: absolute;
			z-index: 99;
			bottom: -142px;
			// padding: 20px 30px;
			padding: calc(var(--proportion) * 40px);
			height: 220px;
			&-left {
				.title {
					font-size: 24px;

					// font-weight: bold;
					// color: #333333;
					color: #ffffff;
					opacity: 0.85;
					margin-bottom: 24px;
					display: flex;
					align-items: center;
					span {
						font-size: 12px;
						font-family: Alibaba PuHuiTi 2;
						font-weight: normal;
						width: 52px;
						height: 20px;
						padding: 3px 8px;
						color: #e60000;
						// background: #fad6d9;
						background: #e6324150;

						border-radius: 2px;
						text-align: center;
						line-height: 20px;
						margin-left: 10px;
					}
					span.over {
						// color: #999999;
						// background: #eeeeee;
						color: #e60000;
						background: #e6324150;
					}
				}
				.item {
					margin-bottom: 16px;
					font-size: 16px;

					font-weight: 400;
					// color: #333333;
					color: #ffffff;
					opacity: 0.85;
					&:last-child {
						margin-bottom: 0;
					}
				}
			}
			&-right {
				height: 100%;
				display: flex;
				flex-wrap: wrap;
				// align-content: space-evenly;
				align-content: space-between;
				justify-content: end;
				.top {
					font-size: 16px;

					font-weight: 400;
					// color: #333333;
					color: #ffffff;
					opacity: 0.85;
					width: 100%;
					text-align: end;
					.top_box {
						font-size: 16px;
						font-weight: 400;
						// color: #333333;
						color: #ffffff;
						width: 100%;
						text-align: end;
					}
				}
				.bottom {
					display: flex;
					align-items: center;
					color: #ffffff;
					.left {
						display: flex;
						align-items: center;
						font-size: 16px;

						font-weight: 400;
						// color: #999999;
						margin-right: 15px;
					}
					.right {
						cursor: pointer;
						font-size: 18px;

						/* font-weight: bold; */
						width: 136px;
						height: 48px;
						background: #e60000;
						text-align: center;
						line-height: 48px;
					}
					.right-end {
						font-size: 18px;

						/* font-weight: bold; */
						width: 136px;
						height: 48px;
						text-align: center;
						line-height: 48px;
					}
				}
			}
		}
	}
	.time-num {
		color: #e60012;
		font-size: 20px;
		font-family: PingFang-SC-Regular;
	}
	.title-box {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 113px;
		margin-bottom: 33px;

		.title {
			font-size: 40px;

			font-weight: bold;
			color: #ffffff;
			opacity: 0.85;
		}
		.fx {
			font-size: 12px;

			font-weight: 400;
			color: #ffffff;
			text-align: center;
			opacity: 0.85;
			width: 52px;
			height: 52px;
			background: #282727;
			// opacity: 0.1;
			border-radius: 4px;
			margin-left: 32px;
			&:hover {
				color: #e60000;
			}
		}
	}
	.info {
		font-size: 14px;

		font-weight: 400;
		color: #ffffff;
		opacity: 0.5;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-bottom: 33px;
		border-bottom: 1px solid #100f0f;
		background: #100f0f;
		box-shadow: 0px 1px 0px 0px #333333;
	}

	.content-box {
		position: relative;
		z-index: 9;
		.content {
			position: relative;
			z-index: 9;
			margin: 0 auto;
			// margin-bottom: 50px;
			// padding: 50px;
			margin-bottom: calc(var(--proportion) * 50px);
			padding: calc(var(--proportion) * 50px);
			box-sizing: border-box;
			width: calc(var(--proportion) * 1200px);
			min-height: 200px;
			// background-color: #fff;
			text-align: center;
		}
		.operate {
			.material-list {
				box-sizing: border-box;
				padding: 0 calc(var(--proportion) * 300px) calc(var(--proportion) * 175px);
				width: 100%;
				//   height: calc(var(--proportion) * 632px);
				//   margin-bottom: 40px;

				.material-content {
					position: relative;
					box-sizing: border-box;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					padding: 0px 40px;
					// overflow-x: scroll;
					// overflow-y: visible;
					width: 100%;
					.swiper-wrapper {
						height: calc(var(--proportion) * 316px);
					}
				}

				.material-content::-webkit-scrollbar {
					/*滚动条整体样式*/
					width: 4px;
					/*高宽分别对应横竖滚动条的尺寸*/
					height: 4px;
				}

				.material-content::-webkit-scrollbar-thumb {
					/*滚动条里面小方块*/
					border-radius: 10px;
					box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
					background: #e60000;
					cursor: pointer !important;
				}

				.material-content::-webkit-scrollbar-track {
					/*滚动条里面轨道*/
					box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
					border-radius: 10px;
					background: rgba(255, 255, 255, 0.1);
				}

				.material-item:hover {
					opacity: 0.8;
				}
				.material-item {
					cursor: pointer;
					position: relative;
					margin: 0px calc(var(--proportion) * 24px);
					overflow: hidden;
					width: 100%;
					// height: calc(var(--proportion) * 247px);
					height: 100%;
					flex-shrink: 0;

					img.hover {
						transform: scale(1.2);
					}

					img {
						width: 100%;
						// height: 78%;
						height: calc(var(--proportion) * 234px);
						object-fit: cover;
					}

					.material-item-popup {
						// position: absolute;
						// top: 0px;
						// left: 0px;
						// z-index: 4;
						// display: flex;
						// justify-content: center;
						// align-items: center;
						// flex-direction: column;
						// width: 100%;
						// height: 100%;
						// background: rgba(0, 0, 0, 0.5);
						height: calc(var(--proportion) * 72px);
						background: #1b1b1b;
						padding: calc(var(--proportion) * 24px);

						.item-popup-title {
							// text-align: center;
							// font-size: 1.1rem;
							// color: rgba(255, 255, 255, 0.85);
							// font-weight: bold;
							// line-height: 18px;

							font-size: 0.6rem;
							font-weight: 200;
							color: #ffffff;

							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}

						.btn-download:hover {
							opacity: 0.9;
						}

						.btn-download {
							margin-top: calc(var(--proportion) * 20px);
							display: flex;
							justify-content: center;
							align-items: center;
							width: 114px;
							height: 48px;
							background: #e60000;
							font-size: 16px;

							font-weight: 500;
							color: #ffffff;
							cursor: pointer;

							.btn-download-img {
								margin-left: 7px;
								width: 11px;
								height: 12px;
							}
						}
					}
					.material-item-tip {
						position: absolute;
						top: 10px;
						right: 10px;
						width: 52px;
						height: 24px;
						background: #000000;
						opacity: 0.5;
						border-radius: 4px;
						text-align: center;
						line-height: 24px;
						font-size: 14px;
						font-family: Alibaba PuHuiTi 2;
						font-weight: normal;
						color: #ffffff;
					}
				}

				.material-item:nth-child(1) {
					margin-left: 0px;
				}

				.material-item:last-child {
					margin-right: 0px;
				}
			}
		}
		.bj {
			position: absolute;
			bottom: 0;
			overflow: hidden;
			width: 100%;
			img {
				width: 100%;
			}
		}
	}
	.swiper-button-prev {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: -10px;
		background-image: url(../assets/icon/xiangzuo@2x.png);
	}
	.swiper-button-prev:hover,
	.swiper-button-next:hover {
		opacity: 1;
	}
	.swiper-button-prev,
	.swiper-button-next {
		opacity: 0;
	}
	.swiper-button-next {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: -10px;
		background-image: url(../assets/icon/xiangyou@2x.png);
	}
	.left-head-img-group {
		position: relative;
		top: -4px;
		margin-right: 20px;
		width: 110px;
		height: 40px;
		display: flex;
		justify-content: right;
		align-items: center;
	}
	.left-head-img {
		width: 30px;
		height: 30px;
		img {
			border-radius: 50%;
			border: 1px solid #fff;
			width: 40px;
			height: 40px;
		}
	}
	.rich-text {
		color: #fff;
		::v-deep {
			video,
			img {
				max-width: 100%;
			}
		}
	}

	::v-deep {
		// 面包屑
		.el-breadcrumb__inner {
			font-size: 14px;

			font-weight: 400;
			color: #999999 !important;
			&:hover {
				color: $theme-color !important;
			}
		}
	}

	// swiper 左右按钮
	.swiper-button-prev,
	.swiper-button-next {
		opacity: 1;
	}
	.round-img-shelf {
		position: absolute;
		top: calc(var(--proportion) * -234px);
		right: 0px;
		width: 65%;
		overflow: hidden;
		height: calc(var(--proportion) * 860px);
	}

	.round-img-more-1 {
		position: absolute;
		top: 0px;
		right: 0px;
		z-index: 0;
		transform: translateX(58%);
		width: calc(var(--proportion) * 1252px * 2.35);
		height: calc(var(--proportion) * 860px);
	}
	.course-redup {
		position: relative;
		margin: 0px auto;
		margin-bottom: 62px;
		width: calc(var(--proportion) * 1200px);
		height: calc(var(--proportion) * 114px);

		img {
			width: 100%;
			height: 100%;
		}
		.title-redup {
			position: absolute;
			top: calc(var(--proportion) * 20px);
			left: 50%;
			transform: translateX(-50%);
			text-align: center;
			font-size: 0.6rem;
			// font-weight: bold;
			color: #ffffff;
		}
		.btn-redup:active {
			opacity: 0.6;
		}
		.btn-redup:hover {
			color: #fff;
			// background: #e60000;
			border: 1px solid #fff;
		}
		.btn-redup:hover::before {
			z-index: 1;
			width: calc(var(--proportion) * 108px - 2px);
			content: '';
			background-color: #e60000;
		}
		.btn-redup {
			position: absolute;
			top: calc(var(--proportion) * 58px);
			left: 50%;
			transform: translateX(-50%);
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			width: calc(var(--proportion) * 108px);
			height: calc(var(--proportion) * 40px);
			background: #ffffff;
			font-size: 0.42rem;
			font-weight: 400;
			color: #e60000;
			border: 1px solid #fff;
			transition: all 0.6s;
			span {
				position: relative;
				z-index: 2;
				top: 0px;
				line-height: 1;
			}
			.redup-right {
				position: relative;
				z-index: 2;
				margin-left: 4px;
				font-weight: 600;
				font-size: 0.42rem;
				width: 0.42rem;
				height: 0.42rem;
				max-width: 12px;
				max-height: 12px;
				line-height: 1;
			}
		}
		.btn-redup::before {
			position: absolute;
			top: 0px;
			left: 0px;
			transition: all 0.6s;
			width: calc(var(--proportion) * 0px);
			height: calc(var(--proportion) * 40px - 2px);
			content: '';
		}
	}
	.title {
		[data-tag='报名中'] {
			padding: 3px 8px;
			background: rgba(24, 144, 255, 0.2) !important;
			color: #1890ff !important;
			border-radius: 4px;
		}

		[data-tag='报名成功'] {
			padding: 3px 8px;
			background: rgba(18, 177, 66, 0.2) !important;
			color: #12b142 !important;
			border-radius: 4px;
		}

		[data-tag='报名失败'] {
			padding: 3px 8px;
			background: rgba(230, 50, 65, 0.2) !important;
			color: #e60000 !important;
			border-radius: 4px;
		}
	}
</style>
